/**
 * "Preserving the current route" across a sign-out (D8), which is the difference between
 * being re-prompted where you were and being dumped at the front door mid-story.
 */

export interface LoginRedirectState {
  /** Path + search of the route the guard interrupted. */
  from: string;
}

/**
 * Reads the target back off `location.state`, which is attacker-adjacent data: it survives
 * `history.pushState` from anywhere on the origin. Hence the three rules below.
 */
export function readRedirectTarget(state: unknown): string {
  if (typeof state !== 'object' || state === null) return '/';

  const { from } = state as { from?: unknown };
  if (typeof from !== 'string') return '/';

  // Same-origin only: `//evil.example` is a protocol-relative URL, not a path.
  if (!from.startsWith('/') || from.startsWith('//')) return '/';

  // The one rule that is about us rather than about safety: sending a freshly signed-in
  // player back to /login is the redirect loop the guard exists to avoid.
  if (from === '/login' || from.startsWith('/login?')) return '/';

  return from;
}
